module.exports = __webpack_public_path__ + "img/euro.83acb934.svg";